import { Route, useLocation } from "react-router-dom";
import Myhome from "./home";
import HomePage from "./homepage";
import TeachingGroup from "./teach";
import CommonProblem from "./commonproblem";
import Notes from "./notes";
import { useEffect } from "react";
import { ActivityDetail } from "./activitydetail";
import { AssistantIntroduce } from "./assistantintroduce";
import { CourseSchedule } from "./schedule/schedule";
import Course from './course/course'
import { SelfEdit } from "./selfeditindex";
import "./animate/animation.scss";

export const HomeRouter = function Router(props) {
  const { pathname, search } = useLocation();

  useEffect(() => {
    let flag = pathname.split("/");

    if (pathname === "/commonproblem/seid/0") {
      document.documentElement.scrollTop = 0;
      document.querySelector(".home-content").scrollTop = 0;
      document.body.scrollTop = 0;
    }
    if (flag.indexOf("seid") !== -1) {
      if (flag[3] !== 0) {
        return;
      } else {
        document.documentElement.scrollTop = 0;
        document.querySelector(".home-content").scrollTop = 0;
        document.body.scrollTop = 0;
      }
    } else {
      document.documentElement.scrollTop = 0;
      document.querySelector(".home-content").scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, [pathname, search]);

  return (
    <div>
      <Route path="/selfedit/:id" component={SelfEdit} />
      <Route path="/teache/:id" component={AssistantIntroduce} />
      <Route path="/newsdetail/:id" component={ActivityDetail} />
      <Route
        path={[
          "/course/:id",
          // "/course_dynamic/:name",
          // "/course_shadow/:name",
          // "/course_camp/:name",
          // "/course_perspective",
          // "/course_dynamic",
          // "/course_shadow",
          // "/course_camp",
        ]}
        component={Course}
      />
      <Route
        path={[
          "/schedule",
          // "/course_dynamic/:name",
          // "/course_shadow/:name",
          // "/course_camp/:name",
          // "/course_perspective",
          // "/course_dynamic",
          // "/course_shadow",
          // "/course_camp",
        ]}
        component={CourseSchedule}
      />
      <Route path={["/notes/:id", "/notes"]} component={Notes} />
      <Route path={["/commonproblem"]} component={CommonProblem} />
      <Route path="/teach" component={TeachingGroup} />
      <Route path="/" component={HomePage} exact />
    </div>
  );
};
export const RootRouter = function Router(props) {
  // useEffect(() => {
  //   console.log(props.location)
  //   window.scroll = 0
  //   document.documentElement.scrollTop = document.body.scrollTop = 0;
  // }, [props.location])
  return <Route className="animate-route" path="/" component={Myhome} />;
};
